import { defineStore } from 'pinia'
import { ref } from 'vue'

export const useMessageDrawerStore = defineStore(
  'messageDrawer',
  () => {
    // 消息抽屉的显示状态
    const visible = ref(false)
    // 当前参数
    const currentParam = ref(null)
    
    // 设置显示状态
    const setVisible = (isVisible) => {
      visible.value = isVisible
    }
    
    // 显示抽屉，支持传参
    const show = (param = null) => {
      visible.value = true
      currentParam.value = param
    }
    
    // 隐藏抽屉
    const hide = () => {
      visible.value = false
      currentParam.value = null
    }
    
    // 切换显示状态，支持传参
    const toggle = (param = null) => {
      if (visible.value) {
        hide()
      } else {
        show(param)
      }
    }
    
    // 获取当前参数
    const getCurrentParam = () => {
      return currentParam.value
    }
    
    return {
      visible,
      currentParam,
      setVisible,
      show,
      hide,
      toggle,
      getCurrentParam
    }
  }
)
